import { HighChartBuilder } from "../../builders/highchart.builder";
import { ObjectHelpers } from "../../helpers/object-helpers";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";
import { TIIndicatorPointModel } from "../../models/data-point/ti-indicator-point.model";

export class TIDataPointToToIndiciatorPointMapper {
    public static map(rawData: Array<TIIndicatorDataModel>, mainChartPoints: Array<TIChartPointModel>): Array<TIIndicatorDataModel> {
        const result: Array<TIIndicatorDataModel> = [];
        for (const data of rawData) {
            for (const point of data.points) {
                TIDataPointToToIndiciatorPointMapper.mapWithTIDataPoint(point, mainChartPoints);
            }
            
            data.childIndicators = TIDataPointToToIndiciatorPointMapper.map(data.childIndicators, mainChartPoints);
            
            if (!data.chartAreaName) {
                data.chartAreaName = HighChartBuilder.mainChartAreaName;
            }
           
            result.push(data);
        }
        return result;
    }

    public static mapWithTIDataPoint(indicatorPoint: TIIndicatorPointModel, mainChartPoints: Array<TIChartPointModel>) {
        const tiDataPoint = mainChartPoints.find((x: TIChartPointModel) => x.xValue == indicatorPoint.xValue);
        if (tiDataPoint) {
            ObjectHelpers.setProperties(tiDataPoint, indicatorPoint, true);
        }
    }
}